import type { VideoDetailsDto } from '@/src/queries/video/video-detail'
import { useVideoDetailsQuery } from '@/src/queries/video/video-detail'
import { Options } from '../Player'
import { Box } from '@chakra-ui/react'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { useLocationQuery } from '@/src/queries/guest/location-query'
import Image from 'next/image'
const Player = dynamic(() => import('../Player'), { ssr: false })

export default function PlayerWrapper({
  pageUrl,
  videoDetails,
  handlePausePlaying,
  handleInactivity,
  isInactivityTimer,
  handleInactivityTimer,
  embeded
}: {
  pageUrl: string
  videoDetails?: VideoDetailsDto | null
  handlePausePlaying?: Function
  handleInactivity?: Function
  isInactivityTimer: boolean
  handleInactivityTimer: () => void
  embeded?: boolean
}) {
  const { data: queriedVideoDetails } = useVideoDetailsQuery(
    pageUrl,
    videoDetails === undefined
  )
  const resolvedVideoDetails = videoDetails === undefined ? queriedVideoDetails ?? null : videoDetails
  const [videoOptions, setVideoOptions] = useState<Options | null>(null)
  const [isPlayerReady, setIsPlayerReady] = useState(false)
  const { data: locationData } = useLocationQuery()
  const posterSrc =
    resolvedVideoDetails?.sharedImageName || resolvedVideoDetails?.thumbnailImage || ''


  useEffect(() => {
    if (!resolvedVideoDetails) {
      return
    }

    const videoOptionsFromApi: Options = {
      playsinline: true,
      id: resolvedVideoDetails.eventId,
      title: resolvedVideoDetails.eventTitle,
      video_id: resolvedVideoDetails.eventId,
      user_id: resolvedVideoDetails.userId || '',
      country: locationData?.country,
      city: locationData?.city,
      controls: true,
      preload: 'none',
      poster: posterSrc,
      subtitleLink: resolvedVideoDetails.subttl ?? '',
      sources: [
        {
          src: resolvedVideoDetails.hlsLink || '',
          type: 'application/x-mpegURL',
        },
      ],
      // tracks: [
      //   {
      //     kind: "captions",
      //     src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_en.vtt",
      //     srlang: "en",
      //     label: "English",
      //     default: "1",
      //   },
      //   {
      //     kind: "captions",
      //     src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_de.vtt",
      //     srlang: "de",
      //     label: "German",
      //   },
      //   {
      //     kind: "captions",
      //     src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_fr.vtt",
      //     srlang: "fr",
      //     label: "French",
      //   },
      //   {
      //     kind: "captions",
      //     src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_es.vtt",
      //     srlang: "es",
      //     label: "Spanish",
      //   },
      // ],
      creatorId: resolvedVideoDetails.channelData,
      vastUrl: resolvedVideoDetails.adl || '',
      timeInterval: resolvedVideoDetails.time_interval || 5,
      embeded: embeded || false,  
      duration: resolvedVideoDetails.duration || "0",
      onReady: () => setIsPlayerReady(true),
    }
    if (videoOptionsFromApi?.sources?.[0]?.src !== '') {
      setVideoOptions((currentOptions) => {
        if (
          currentOptions?.id === videoOptionsFromApi.id &&
          currentOptions?.sources?.[0]?.src === videoOptionsFromApi.sources?.[0]?.src
        ) {
          return currentOptions
        }

        setIsPlayerReady(false)
        return {
        ...videoOptionsFromApi,
        handlePausePlaying: handlePausePlaying,
        handleInactivity: handleInactivity,
        handleInactivityTimer: handleInactivityTimer
      }
      })
    }
  }, [
    embeded,
    handleInactivity,
    handleInactivityTimer,
    handlePausePlaying,
    locationData?.city,
    locationData?.country,
    posterSrc,
    resolvedVideoDetails,
  ])


  if (!resolvedVideoDetails) {
    return <Box aspectRatio={16 / 9} bg="black" w="100%" />
  }

  return (
    <Box aspectRatio={16 / 9} bg="black" className="relative overflow-hidden">
      {posterSrc && !isPlayerReady && (
        <Image
          src={posterSrc}
          alt={resolvedVideoDetails.eventTitle || 'Video poster'}
          fill
          priority
          sizes="(max-width: 991px) 100vw, 70vw"
          style={{ objectFit: 'cover' }}
        />
      )}
      {videoOptions && <Player {...videoOptions} />}
      {/* Overlay Text */}
      {
        isInactivityTimer && (
          <div className="absolute bottom-16 left-1/2 transform -translate-x-1/2 bg-[#383838] text-white text-center px-4 py-2 rounded-md text-sm md:text-base lg:text-lg z-10">
            Your video has been paused due to inactivity.<br></br>
            Click Play to resume.
          </div>
        )}
    </Box>
  )
}